// Must run before anything touches the network.
import { installNetworkLedger } from './lib/network-ledger';
import { listenToLedger } from './state/ledger-store';
import { StrictMode } from 'react';
import { analytics } from './analytics';
import { createRoot } from 'react-dom/client';
import './i18n';
import './styles/app.css';
import { cleanupStaleExports } from './engine/export/file-target';
import { registerServiceWorker } from './lib/pwa';
import { initTheme } from './lib/theme';
import { handFiles } from './state/handoff';
import { App } from './ui/App';
import { installFloatingHost } from './ui/recording/floating-window';

export interface StartOptions {
  /** Files a content page was given before it turned into the app; they open as if dropped on the home page. */
  readonly files?: readonly File[];
}

/** Starts the app in `root`: from index.html, or in place of a content page that was handed a video (src/intake). */
export function startApp(root: HTMLElement, { files = [] }: StartOptions = {}): void {
  listenToLedger();
  installNetworkLedger();
  // Only when the visitor agreed earlier (here or on a content page); otherwise home asks.
  analytics.start();
  initTheme();
  void registerServiceWorker();
  installFloatingHost();
  if ('storage' in navigator && 'getDirectory' in navigator.storage) void cleanupStaleExports().catch(() => undefined);
  if (files.length > 0) handFiles(files);
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
